import { ReactNode } from 'react';
import styled from 'styled-components';
import { text, textLinkPrimary } from 'styles-js/mixins/typography';

type Props = {
  items: string[] | ReactNode[];
};
export default function BulletedList({ items = [] }: Props) {
  return (
    <List>
      {items.map((item) => (
        <Item key={item}>
          <Bullet />
          <Text>
            {item}
          </Text>
        </Item>
      ))}
    </List>
  );
}

const List = styled.div`
  padding: 0px;
  margin-left: 15px;
  clear: both;
`;
const Item = styled.div`
  padding: 0px 0px 10px 0px;
`;
const Bullet = styled.div`
  background-color: ${({ theme }) => theme.colorGreen};
  border-radius: 30px;
  height: 8px;
  width: 8px;
  margin-top: 7px;
  font-size: 20px;
  float: left;
  clear: both;
`;
const Text = styled.div`
  ${text}
  margin-left: 18px;

  a {
    ${textLinkPrimary}
  }
`;
